








import { Vue, Component } from 'vue-property-decorator'
import CountryFlag from 'vue-country-flag'
import { Messages } from '@/assets/langs/langs'


type langFlagMapping = { lang: string, flag: string, label: string }

@Component({
  components: {
    CountryFlag
  }
})
export default class LanguageSelector extends Vue {
public langOptions: Array<langFlagMapping> = [
  { lang: 'fr', flag: 'fr', label: 'Français' },
  { lang: 'en', flag: 'gb', label: 'English' }
]

get currentFlag () {
  return this.langOptions.find(langOption => langOption.lang === this.$store.getters.lang)?.flag
}

get messages () {
  return <Messages['components']['LanguageSelector']>this.$store.getters.messages.components.LanguageSelector
}

async changeLang (lang: string): Promise<void> {
  await this.$store.dispatch('changeLang', lang)
}

}
